import React from "react";
import { TabbedCodeExample } from "../../../../../src/markdown-components";

const importRouteHandler = `import { RouteHandler } from "gadget-server";\n\n`;
const exportDefault = `\n\nexport default route;\n`;

export const getRouteFunctionSignatureWithShopId = (isTs: boolean) =>
  isTs
    ? "const route: RouteHandler<{ Params: { shopId: string }; }> = async ({ request, reply, api, connections }) => {"
    : "/** @type { RouteHandler<{ Params: { shopId: string }; }> }*/\nconst route = async ({ request, reply, api, logger, connections }) => {";

export const getRouteFunctionSignatureWithShopDomain = (isTs: boolean) =>
  isTs
    ? "const route: RouteHandler<{ Params: { shopDomain: string }; }> = async ({ request, reply, api, connections }) => {"
    : "/** @type { RouteHandler<{ Params: { shopDomain: string }; }> }*/\nconst route = async ({ request, reply, api, logger, connections }) => {";

export const GetProductsFromShopIdCodeSnip = () => {
  return (
    <TabbedCodeExample
      filename="api/routes/GET-products.ts"
      disableTranspiler
      useRawCode
      examples={{
        javascript: importRouteHandler + getRouteFunctionSignatureWithShopId(false) + getProductsFromShopIdBody + exportDefault,
        typescript: importRouteHandler + getRouteFunctionSignatureWithShopId(true) + getProductsFromShopIdBody + exportDefault,
      }}
    />
  );
};

const getProductsFromShopIdBody = `  const { shopId } = request.params;
  const shopify = await connections.shopify.forShopId(shopId);

  const products = await shopify.graphql(
    \`query {
      products(first: 10) {
        edges {
          node {
            id
            title
            handle
          }
          cursor
        }
        pageInfo {
          hasNextPage
        }
      }
    }\`
  );

  await reply.send({
    products,
  });
}`;

export const GetProductsFromShopDomainCodeSnip = () => {
  return (
    <TabbedCodeExample
      filename="api/routes/GET-products.ts"
      disableTranspiler
      useRawCode
      examples={{
        javascript: importRouteHandler + getRouteFunctionSignatureWithShopDomain(false) + getProductsFromShopDomainBody + exportDefault,
        typescript: importRouteHandler + getRouteFunctionSignatureWithShopDomain(true) + getProductsFromShopDomainBody + exportDefault,
      }}
    />
  );
};

const getProductsFromShopDomainBody = `const { shopDomain } = request.params;
  const shopify = await connections.shopify.forShopDomain(shopDomain);

  const products = await shopify.graphql(
    \`query {
      products(first: 10) {
        edges {
          node {
            id
            title
            handle
          }
          cursor
        }
        pageInfo {
          hasNextPage
        }
      }
    }\`
  );

  await reply.send({
    products,
  });
}
`;

export const GetProductsFromWithForShopCodeSnip = () => {
  return (
    <TabbedCodeExample
      filename="api/routes/GET-products.ts"
      disableTranspiler
      useRawCode
      examples={{
        javascript: importRouteHandler + getRouteFunctionSignatureWithShopId(false) + getProductsFromWithForShop + exportDefault,
        typescript: importRouteHandler + getRouteFunctionSignatureWithShopId(true) + getProductsFromWithForShop + exportDefault,
      }}
    />
  );
};

const getProductsFromWithForShop = `  const { shopId } = request.params;

  const shop = await api.internal.shopifyShop.findOne(shopId);
  // @ts-ignore
  const shopify = connections.shopify.forShop(shop);

  const products = await shopify.graphql(
    \`query {
      products(first: 10) {
        edges {
          node {
            id
            title
            handle
          }
          cursor
        }
        pageInfo {
          hasNextPage
        }
      }
    }\`
  );

  await reply.send({
    products,
  });
}`;
